"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const routeControlPointService = {
  createRouteControlPoint: function (options) {
    return api.post(`/RouteControlPoints`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteRouteControlPoint: function (options) {
    return api.delete(
      `/RouteControlPoints`,
      WithToken.headersToken({ params: { routeId: options.routeId, controlPointId: options.controlPointId } }, configuration.cookieName)
    );
  },
};

export default routeControlPointService;
